<template>
  <section>
    <div v-if="progressData.length > 0" class="keduBuFen">
      <div class="bigs1">
        <div class="hui">
          <template v-for="(item, index) in progressData">
            <div class="viewsmall"></div>
            <div class="zhongJianSelect" v-if="item.statu"></div>
            <div class="zhongJian" v-else></div>
          </template>
        </div>
        <!--刻度杠  -->
        <div class="huang" :style="'width:' + width + '%'"></div>
      </div>
      <div class="bigs2">
        <div class="viewbig">
          <div
            class="viewsmall2"
            v-for="(item, index) in progressData"
            :key="index"
          >
            <div
              :class="
                'viewsmall2Text' + !item.statu ? 'viewsmall2TextSelect' : ''
              "
            >
              {{ item.Name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "TourDiyProgress",
  data() {
    return {
      width: 0,
      p: 0,
    };
  },
  props: {
    progressData: {
      type: Array,
      value: null,
    },
    ItemCount: {
      type: Number,
      value: 0,
    },
  },
  watch: {
    ItemCount: function (data) {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      var progressData = this.progressData;
      var num = this.ItemCount;
      var p = 0;
       if(progressData.length<=0){
        return;
      }
      for (var i = 0; i < progressData.length; i++) {
        if (progressData[i].Number > num) {
          p = i;
          break;
        }
      }
      if (i == progressData.length) {
        p = i;
      }
      for (var j = 0; j < p; j++) {
        progressData[j].statu = true;
      }
      if (p == 0) {
        var maxnum = progressData[0].Number;
        num = (num / maxnum) * (100/progressData.length);
      } else if (progressData[p - 1].Number < num) {
        num = ((p + 0.5) / progressData.length) * 100;
        //毕竟不是当前进度等分，所以让他在等于8，7，6的时候也能在中间。就加0.5
      } else {
        num = (p / progressData.length) * 100;
        //当前黄色进度长度就是当前人数除以总人数乘以100，就是进度条宽度的百分比。
      }
      this.width = num > 100 ? 100 : num;
      this.p = p;
      this.progressData = progressData;
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style scoped>
/*进度条  */
.keduBuFen {
  padding-top: 10px;
}

.bigs1 {
  width: 95%;
  position: relative;
}

.bigs2 {
  width: 95%;
  margin: 0px auto;
  position: relative;
}

.hui {
  width: 100%;
  height: 3px;
  background: #e2e2e2;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.viewsmall {
  flex: 1;
  height: 3px;
}

.zhongJianSelect {
  width: 12px;
  height: 12px;
  border-radius: 12px;
  background: #fff !important;
  border: 3px solid #fab13e;
  top: 28px;
  margin: -5px;
  z-index: 11;
}

.zhongJian {
  width: 12px;
  height: 12px;
  border-radius: 12px;
  background: #e1e1e1;
  top: 28px;
  margin: -5px;
  z-index: 12;
}

.gangBig {
  position: absolute;
  left: 0;
  bottom: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.huang {
  position: absolute;
  height: 3px;
  background: #fab13e;
  left: 0;
  bottom: 0px;
  display: flex;
  flex-direction: row;
  float: left;
}

.viewbig {
  width: 100%;
  height: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: nowrap;
  padding: 5px 0;
}

.viewsmall2 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.viewsmall2Text {
  color: #fab750;
  font-size: 13px;
  text-align: right;
}

.viewsmall2TextSelect {
  color: #574c46;
  font-size: 13px;
  text-align: right;
}

.touXiangImgView1 {
  display: flex;
  flex-direction: column;
}

.touXiangImgView {
  display: flex;
  flex-direction: column;
  float: left;
  height: 124px;
  width: 94px;
  margin: 10rpx 5px;
  padding-top: 5px;
}

.touXiangImgView2 {
  height: 124px;
}
</style>